module.exports = __webpack_public_path__ + "img/9791189015503.d6d4ea8f.jpg";